import { render, staticRenderFns } from "./MerchantsSlider.vue?vue&type=template&id=585f196d&"
import script from "./MerchantsSlider.vue?vue&type=script&lang=js&"
export * from "./MerchantsSlider.vue?vue&type=script&lang=js&"
import style0 from "./MerchantsSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports